import type { ContainerProps } from "@/types";

/**
 * Container Component
 * Max-width wrapper with responsive padding
 * Provides consistent page width across the application
 */
export const Container = ({
  children,
  className = '',
  maxWidth = 'xl',
}: ContainerProps) => {
  // Max-width classes
  const maxWidthClasses = {
    sm: 'max-w-screen-sm',
    md: 'max-w-screen-md',
    lg: 'max-w-screen-lg',
    xl: 'max-w-screen-xl',
    '2xl': 'max-w-screen-2xl',
    full: 'max-w-full',
  };

  return (
    <div className={`mx-auto px-4 sm:px-6 lg:px-8 ${maxWidthClasses[maxWidth]} ${className}`}>
      {children}
    </div>
  );
};

export default Container;
